import {Component, Input, OnInit, signal, ViewChild} from '@angular/core';
import {CustomerArea} from '../../classes/customerarea.class';
import {PushpinFilterComponent} from '../pushpin-filter/pushpin-filter.component';
import {PushpinService} from '../../services/pushpin/pushpin.service';
import {PushpinFilter} from '../../pushpin-filter';
import {Settings} from '../../settings.class';
import {combineLatest} from 'rxjs';
import {Pushpin} from '../../classes/pushpin.class';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {StatusService} from '../../services/status/status.service';
import {MaterialService} from '../../services/material/material.service';
import {DecorationsService} from '../../services/decorations/decorations.service';
import {PaintColorService} from '../../services/paintColor/paint-color.service';
import {PushpinImage} from '../../classes/pushpin-image.class';
import {PushpinPart} from '../../classes/pushpinpart.class';
import {CordovaService} from '../../cordova.service';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {PushpinSelectionComponent} from '../pushpin-selection/pushpin-selection.component';
import {PricesService} from '../../services/prices/prices.service';
import {CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport} from '@angular/cdk/scrolling';
import {MaterialPrice} from '../../classes/materialprice.class';
import {DecorationPrice} from '../../classes/decorationprice.class';
import {CustomerAreaService} from '../../services/consumer-area/customer-area.service';
import {MatDialog} from '@angular/material/dialog';
import {PushpinExportComponent} from '../pushpin-export/pushpin-export.component';
import {PushpinShapeExportComponent} from '../pushpin-shape-export/pushpin-shape-export.component';
import {CodaltComponent} from '../../codalt.component';
import {Inspection} from '../../classes/inspection';
import {saveAs} from 'file-saver';
import {DatePipe, DecimalPipe, formatDate} from '@angular/common';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LocalStorage} from '../../storage.class';
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {MatTooltip} from "@angular/material/tooltip";
import {MatOption, MatSelect} from "@angular/material/select";
import {MatBadge} from "@angular/material/badge";
import {SafeBgUrlPipe} from "../../pipes/safe-bg-url.pipe";
import {VvrIconComponent} from "../../vvr-icon/vvr-icon.component";

declare var cordova;

@Component({
    selector: 'app-pushpin-list',
    templateUrl: './pushpin-list.component.html',
    styleUrls: ['./pushpin-list.component.scss'],
    imports: [
        MatFormField,
        MatTooltip,
        MatLabel,
        MatSelect,
        ReactiveFormsModule,
        MatOption,
        FormsModule,
        MatInput,
        MatBadge,
        RouterLink,
        DatePipe,
        DecimalPipe,
        SafeBgUrlPipe,
        VvrIconComponent,
        CdkVirtualScrollViewport,
        CdkFixedSizeVirtualScroll,
        CdkVirtualForOf
    ]
})
export class PushpinListComponent extends CodaltComponent implements OnInit {

    @Input() nearby: boolean;

    readonly showPriceSelectionBar = signal<boolean>(false);

    @Input()
    filterComponent: PushpinFilterComponent;

    @Input()
    selectionComponent: PushpinSelectionComponent;

    @ViewChild('scrollviewport')
    scrollviewport: CdkVirtualScrollViewport;

    readonly zipExporting = signal<boolean>(false);
    readonly loading = signal<boolean>(false);
    readonly showList = signal<boolean>(false);
    readonly isSmallDevice = signal<boolean>(false);

    readonly pushpins = signal<Pushpin[]>([]);
    readonly pushpinParts = signal<PushpinPart[]>([]);
    readonly searchedPushpinParts = signal<PushpinPart[]>([]);
    readonly imagesMap = signal<object>({});
    readonly mapCenter = signal(null);
    readonly mapZoom = signal<number>(null);
    customerArea: CustomerArea;
    readonly inspection = signal<Inspection>(null);
    readonly showName = signal<boolean>(false);
    readonly showPrice = signal<boolean>(false);
    readonly tableView = signal<boolean>(false);
    readonly pushpinPartPricesMap = signal<any>(null);
    private readonly _order = signal('date');
    private readonly _searchText = signal('');
    private readonly latestUpdatedAt = signal(-1);
    private readonly deviceHasInternet = signal<boolean>(true);

    constructor(
        private pushpinService: PushpinService,
        private pricesService: PricesService,
        private activatedRoute: ActivatedRoute,
        private statusService: StatusService,
        private materialService: MaterialService,
        private decorationsService: DecorationsService,
        private paintColorService: PaintColorService,
        private cordovaService: CordovaService,
        private confirmDialogService: ConfirmDialogService,
        private customerAreaService: CustomerAreaService,
        public dialog: MatDialog,
        private router: Router
    ) {
        super();
        this.isCordova = false;
        this.filter = Settings.pushpinFilter;
        this.columnSelection = Array.from(this.tableColumns.values());

        this.subscriptions.add(this.fcTableColumns.valueChanges.subscribe(selectedColumns => {
            this.columnSelection.forEach(c => {
                c.visable = selectedColumns.includes(c.column);
            });
            this.header = Array.from(this.tableColumns.values()).filter(h => h.visable);
            this.tableWidth = Array.from(this.header.values()).map(d => +d.width || 0).reduce((p, c) => p + c, 0);
            LocalStorage.saveTableColumns(selectedColumns);
        }));
        this.fcTableColumns.setValue(LocalStorage.getTableColumns() ?? Array.from(this.tableColumns.values()).filter(h => h.visable).map(h => h.column));
    }

    // Getters and setters for ngModel two-way binding
    get order(): string {
        return this._order();
    }

    private keyValMap = {};

    set order(value: string) {
        this._order.set(value);
    }

    private filter: PushpinFilter;

    get searchText(): string {
        return this._searchText();
    }

    private materialPrices: MaterialPrice[];
    private decorationPrices: DecorationPrice[];

    tableColumns = new Map<string, { column: string, name: string, visable: boolean, width: number }>([
        ['number', {column: "number", name: "Nummer", visable: true, width: 110}],
        ['updated_at', {column: "updated_at", name: "Datum", visable: false, width: 150}],
        ['executedDate', {column: "executedDate", name: "Uitgevoerd", visable: false, width: 150}],
        ['zipcode', {column: "zipcode", name: "Postcode", visable: false, width: 150}],
        ['place', {column: "place", name: "Plaats", visable: true, width: 150}],
        ['street', {column: "street", name: "Straat", visable: true, width: 150}],
        ['housenumber', {column: "housenumber", name: "Huisnummer", visable: true, width: 150}],
        ['price', {column: "price", name: "Prijs", visable: true, width: 150}],
        ['inQuotation', {column: "inQuotation", name: "In offerte", visable: true, width: 150}],
        ['status', {column: "status", name: "Status", visable: true, width: 150}],
        ['decorationType', {column: "decorationType", name: "Figuratie type", visable: true, width: 150}],
        ['decorationName', {column: "decorationName", name: "Figuratie", visable: true, width: 200}],
        ['material', {column: "material", name: "Materiaal", visable: true, width: 200}],
        ['paint_color', {column: "paint_color", name: "Kleur", visable: true, width: 90}],
        ['length', {column: "length", name: "Lengte", visable: true, width: 100}],
        ['surface', {column: "surface", name: "Oppervlakte", visable: true, width: 120}],
        ['amount', {column: "amount", name: "Aantal", visable: true, width: 90}],
        ['crow', {column: "crow", name: "Crow", visable: true, width: 80}],
        ['blast', {column: "blast", name: "Stralen", visable: true, width: 90}],
        ['stake_out', {column: "stake_out", name: "Uitzetten", visable: true, width: 90}],
        ['priority_figuration', {column: "priority_figuration", name: "Voorrangsfiguratie", visable: true, width: 170}],
        ['turbo_burn', {column: "turbo_burn", name: "Turbo branden", visable: true, width: 150}],
        ['manual_burn', {column: "manual_burn", name: "Handmatig branden", visable: true, width: 180}],
        ['night', {column: "night", name: "Nacht", visable: true, width: 80}],
        ['lat', {column: "lat", name: "latitude", visable: false, width: 150}],
        ['lng', {column: "lng", name: "longitude", visable: false, width: 150}],
        ['description', {column: "description", name: "Opmerking", visable: false, width: 150}],
        ['reference', {column: "reference", name: "Referentie", visable: false, width: 150}],
        ['customer_note', {column: "customer_note", name: "Opmerking Klant", visable: false, width: 150}]
    ]);

    header: { column: string, name: string, visable: boolean, width: number }[];
    columnSelection: { column: string, name: string, visable: boolean, width: number }[];
    tableWidth: number;

    fcTableColumns = new FormControl();

    set searchText(value: string) {
        this._searchText.set(value);
    }

    scrolling(event) {
        document.querySelector('.header').scrollLeft = document.querySelector('.viewport').scrollLeft;
    }

    ngOnInit(): void {
        this.isSmallDevice.set(window.matchMedia('(max-width: 767px)').matches);
        this.pushpinPartPricesMap.set(this.pricesService.pushpinPartPricesMap);
        if (this.AuthorisationService.hasFeature('listShowNames')) {
            this.showName.set(true);
        }
        this.showPrice.set(this.AuthorisationService.hasFeature('priceList'));
        this.subscriptions.add(this.cordovaService.deviceHasInternet.subscribe((hasInternet) => {
            this.deviceHasInternet.set(hasInternet);
        }));
        this.subscriptions.add(this.filterComponent.filterEmitter.subscribe((filter) => {
            this.filter = filter;
            this.latestUpdatedAt.set(-1);
        }));

        this.subscriptions.add(this.activatedRoute.params.subscribe(params => {
            if (params['zoom']) {
                this.mapZoom.set(+params['zoom']);
            }

            if (params['lat'] && params['lng']) {
                this.mapCenter.set({
                    lat: params['lat'],
                    lng: params['lng']
                });
            }

            if (params['view'].indexOf('list') !== -1) {
                if (this.selectionComponent) {
                    this.selectionComponent.calculatePrices();
                }
                if (params['view'] === 'list') {
                    this.showList.set(true);
                }
            } else {
                this.showList.set(false);
            }
        }));
    }

    search() {
        const matchesPrice = this._searchText().match(/^([><]) ?([0-9]+)$/);
        if (this._searchText().match(/^[0-9]+$/)) {
            this.searchedPushpinParts.set(
                this.pushpinParts()
                    .filter(p => (p.pushpin.number + '' === this._searchText().trim()) || p.pushpin.reference + '' === this._searchText().trim())
            );
        } else if (matchesPrice && this.showPrice()) {
            if (matchesPrice[1] === '>') {
                this.searchedPushpinParts.set(this.pushpinParts().filter(p => this.pushpinPartPricesMap()[p.id] > (+matchesPrice[2])));
            } else {
                this.searchedPushpinParts.set(this.pushpinParts().filter(p => this.pushpinPartPricesMap()[p.id] < (+matchesPrice[2])));
            }
        } else if (this._searchText()) {
            this.searchedPushpinParts.set(this.pushpinParts()
                .filter(p =>
                    ((p.pushpin.street || '').toLowerCase() + '|' +
                        (p.decoration.name || '').toLowerCase() + '|' +
                        (p.pushpin.place || '').toLowerCase() + '|' +
                        (p.description || '').toLowerCase() + '|' +
                        (p.pushpin.description || '').toLowerCase() + '|' +
                        (p.pushpin.reference || '').toLowerCase() + '|' +
                        (p.customer_note || '').toLowerCase()
                    ).indexOf(this._searchText().toLowerCase().trim()) !== -1));
        } else {
            this.searchedPushpinParts.set(this.pushpinParts());
        }
        this.sortList(this._order());
    }

    zipExport() {
        this.zipExporting.set(true);
        this.customerAreaService.zip(this.customerArea.id, this.inspection()?.id).subscribe(zip => {
            const date = formatDate(new Date(), 'dd-MMM-yyyy', 'nl').replace('.', '');
            saveAs(zip, `Afbeeldingen ${this.customerArea.name} ${date}.zip`);
            this.zipExporting.set(false);
        });
    }

    excelExport() {
        const dialogRef = this.dialog.open(PushpinExportComponent, {
            data: {
                customerArea: this.customerArea,
                inspection: this.inspection()
            },
            panelClass: 'excel-export-dialog'
        });
    }

    shapeFileExport() {
        this.dialog.open(PushpinShapeExportComponent, {
            data: {
                customerArea: this.customerArea,
                inspection: this.inspection()
            },
            panelClass: 'shapefile-export-dialog'
        });
    }

    orderChanged(event) {
        const sortingOn = event.value;

        this.sortList(sortingOn);
    }

    public setSelection(event, pushpinPart: PushpinPart) {
        event.preventDefault();
        event.stopPropagation();
        pushpinPart['checked'] = !pushpinPart['checked'];
        if (pushpinPart['checked']) {
            this.selectionComponent.addPushpinPart(pushpinPart);
        } else {
            this.selectionComponent.removePushpinPart(pushpinPart);
        }
    }

    public setCustomerArea(customerArea: CustomerArea, inspection: Inspection) {
        this.customerArea = customerArea;
        this.inspection.set(inspection);
        this.showSelectionBarDecider(inspection);
        this.subscriptions.add(this.filterComponent.filterEmitter.subscribe(filter => {
            if (filter.deleted) {
                this.showPriceSelectionBar.set(false);
            } else {
                this.showSelectionBarDecider(inspection);
            }
        }));
    }

    public toggleFilter() {
        this.filterComponent.toggleFilter();
    }

    public reloadPushpins(pushpins: Pushpin[]) {
        this.loading.set(true);
        this.pushpinParts.set([]);

        // First, get the images map, then build the pushpin parts with images already set
        const loadPushpinParts = (imagesMap: any) => {
            pushpins?.forEach((pushpin: Pushpin) => {
                if (pushpin.pushpin_parts) {
                    pushpin.pushpin_parts.forEach(pushpinPart => {
                        pushpinPart.decoration = this.keyValMap['decoration_id'][pushpinPart.decoration_id];
                        if (pushpinPart.decoration) {
                            pushpinPart.material = this.keyValMap['material_id'][pushpinPart.material_id];
                            pushpinPart.paint_color = this.keyValMap['paint_color_id'][pushpinPart.paint_color_id];
                            pushpinPart.status = this.keyValMap['status_id'][pushpinPart.status_id];
                            pushpinPart.images = [];
                            const image = new PushpinImage();

                            // Set the image URL immediately before adding to the signal
                            if (imagesMap && typeof imagesMap[pushpinPart.id] !== 'undefined') {
                                image.image = imagesMap[pushpinPart.id];
                            }

                            pushpinPart.images.push(image);
                            pushpinPart['pushpin'] = pushpin;
                            pushpinPart.updated_at = new Date(pushpinPart.updated_at);
                            if (pushpinPart.decoration.type === 'Vlak' || pushpinPart.decoration.type === 'Diversen vervangen' || !pushpinPart.decoration.specify_length) {
                                pushpinPart.surface = this.pricesService.calculateSurface(pushpinPart);
                            }

                            this.pushpinParts.update(parts => [...parts, pushpinPart]);
                        }
                    });
                } else {
                    pushpin.pushpin_parts = [];
                }
            });
            this.pushpins.set(pushpins);

            if (this.showPrice() && this.inspection()) {
                this.pricesService.getItemsWithPrices([this.inspection().id]).subscribe(prices => {
                    this.materialPrices = prices['materialPrices'];
                    this.decorationPrices = prices['decorationPrices'];
                    this.pushpinParts().forEach(pushpinPart => {
                        this.pricesService.calculatePushpinPartPrice(pushpinPart, this.materialPrices, this.decorationPrices);
                    });
                    this.search();
                    this.sortList(this._order());
                });
            } else {
                this.search();
                this.sortList(this._order());
            }
        };

        if (this.customerArea) {
            this.pushpinService.getPushpinPartImagesMap(this.customerArea.id).then(imagesMap => {
                this.imagesMap.set(imagesMap);
                loadPushpinParts(imagesMap);
                this.setPushpinCustomerSelectionCheckoxes();
            });
        } else {
            const pushpinPartIds = [].concat.apply([], pushpins.map(p => p.pushpin_parts.map(p => p.id)));
            this.pushpinService.getPushpinPartImagesMapByIds(pushpinPartIds).then(imagesMap => {
                this.imagesMap.set(imagesMap);
                loadPushpinParts(imagesMap);
            });
        }
    }

    public initKeyValMapData(pushpins) {
        const status$ = this.statusService.getKeyValMap();
        const decorations$ = this.decorationsService.getKeyValMap();
        const materials$ = this.materialService.getMaterialsAsKeyValueMap(true);
        const paintColor$ = this.paintColorService.getKeyValMap();
        combineLatest([status$, decorations$, materials$, paintColor$])
            .subscribe(([status, decoration, material, paintColor]) => {
                this.keyValMap['status_id'] = status;
                this.keyValMap['decoration_id'] = decoration;
                this.keyValMap['material_id'] = material;
                this.keyValMap['paint_color_id'] = paintColor;
                this.reloadPushpins(pushpins);
            });
    }

    public openPushpin(pushpinId: number, pushpinPartId: number) {
        if (this.deviceHasInternet()) {
            this.router.navigate([
                'pushpins/list-detail',
                pushpinId,
                this.mapZoom(),
                this.mapCenter().lat,
                this.mapCenter().lng,
                {pushpinPartId: pushpinPartId, inspection: this.inspection()?.id}
            ]);
        } else {
            this.confirmDialogService.confirm(
                'Geen Internet',
                'Het apparaat heeft momenteel geen internetverbinding, de punaise kan daarom niet worden geopend.',
                'Oké',
                null).then(() => {

            }, () => {

            });
        }
    }

    back() {
        this.customerAreaService.getList().then(customerAreas => {
            if (customerAreas.length < 2) {
                this.router.navigate(['/']);
            } else {
                this.router.navigate(['/customer-selection']);
            }
        });
    }

    private showSelectionBarDecider(inspection: Inspection) {
        this.showPriceSelectionBar.set((
                (this.AuthorisationService.hasFeature('priceList') && inspection?.inspection_status_id > 2)
                || this.AuthorisationService.hasFeature('showPushpinSelectionBarAlways')
            )
            && window.matchMedia('(min-width: 1100px)').matches);
    }

    private sortList(sortingOn) {
        let pushpinParts = this.searchedPushpinParts();
        this.searchedPushpinParts.set([]);
        if (sortingOn === 'date') {
            pushpinParts = pushpinParts.sort((a, b) =>
                (new Date(a.updated_at)).getTime() - (new Date(b.updated_at)).getTime()
            );
        }
        if (sortingOn === '-date') {
            pushpinParts = pushpinParts.sort((a, b) =>
                (new Date(b.updated_at)).getTime() - (new Date(a.updated_at)).getTime()
            );
        }
        if (sortingOn === 'price') {
            pushpinParts = pushpinParts.sort((a, b) =>
                this.pushpinPartPricesMap()[a.id] - this.pushpinPartPricesMap()[b.id]
            );
        }
        if (sortingOn === '-price') {
            pushpinParts = pushpinParts.sort((a, b) =>
                this.pushpinPartPricesMap()[b.id] - this.pushpinPartPricesMap()[a.id]
            );
        }
        if (sortingOn === 'number') {
            pushpinParts = pushpinParts.sort((a, b) =>
                a.pushpin.number - b.pushpin.number
            );
        }
        if (sortingOn === '-number') {
            pushpinParts = pushpinParts.sort((a, b) =>
                b.pushpin.number - a.pushpin.number
            );
        }
        this.searchedPushpinParts.set(pushpinParts);
    }

    private setPushpinCustomerSelectionCheckoxes() {
        this.pushpinParts().forEach(pushpinParts => {
            pushpinParts['checked'] = this.pricesService.selectedPushpinParts().filter(_pushpinPart => {
                return _pushpinPart.id === pushpinParts.id;
            }).length > 0;
        });
    }
}
